<div class="container-fluid container-xxl overflow-hidden gx-lg-10 gx-xxl-0">
    <div class="row align-items-center">
        <div class="col-md-6">
            <div class="pe-xl-14 mb-7 mb-lg-0 pt-9">
                <div class="partner-logo mb-10">
                    <img [src]="'assets/images/partners/' + partner.logoURL" alt="" />
                </div>
                <h5 class="font-secondary text-secondary fs-14 fw-700">
                    {{ partner.name }}
                </h5>
                <a class="fs-12 text-gray-200 d-inline-flex align-items-center fs-12 text-gray-200 mb-5" [href]="partner.website" target="_blank">
                    <div class="icon icon-s me-2">
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="external-link-alt"
                            class="svg-inline--fa fa-external-link-alt fa-w-16"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="currentColor"
                                d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                            ></path>
                        </svg>
                    </div>
                    <span>{{ 'PARTNERS.check_website' | translate }}</span>
                </a>
                <p class="font-primary fs-16 lh-29" [innerHtml]="partner.description | translate"></p>
            </div>
        </div>
        <div class="col-md-6">
            <img class="w-100 d-block" [src]="'assets/images/partners/' + partner.photo" alt="" />
        </div>
    </div>
</div>
